import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';
import { bind } from 'app/_decorators/bind.decorator';
import { TradeUploadWizardContext } from 'app/trade-upload-wizard/trade-upload-wizard.component';

class UploadWizardSelectComponentCtrl implements ng.IController {
    public tradeAndTradeProposals: DataPageDto<TradeAndTradeProposalDto>;
    public params: any = {};
    public currentPage: number = 1;
    public sortColumn: string;
    public itemsPerPage: number = 10;
    public sortAscending: boolean = true;
    public errorMessage: string;
    public loading: boolean = false;
    public tradeTypeError: boolean = false;
    public hasActiveFilter: boolean;
    private wizardCtrl: mgoAngularWizard.Wizard<TradeUploadWizardContext>;
    private selectedType: TradeType;

    constructor(
        private TradeAndTradeProposals: any,
        private $location: ng.ILocationService,
        private COLUMN_FILTER: any
    ) {}

    $onInit(): void {
        if (!this.wizardCtrl.context.selectedTrade) {
            this.wizardCtrl.context.selectedTrade = [];
        }
        this.sortColumn = this.COLUMN_FILTER.COL.ID;
        this.loadTrades();
    }

    @bind
    public onTradeSelection(trade: TradeAndTradeProposalDto) {
        if (this.wizardCtrl.context.selectedTrade.length > 0) {
            if (this.isChecked(trade)) {
                for (let item of this.wizardCtrl.context.selectedTrade) {
                    if (item.id === trade.id) {
                        this.wizardCtrl.context.selectedTrade.splice(
                            this.wizardCtrl.context.selectedTrade.indexOf(item),
                            1
                        );
                        this.tradeTypeError = false;
                    }
                }
            } else {
                if (this.selectedType === trade.type) {
                    this.wizardCtrl.context.selectedTrade.push(trade);
                    this.tradeTypeError = false;
                } else {
                    const checkBox = <HTMLInputElement>(
                        document.getElementById('selected_' + trade.id)
                    );
                    checkBox.checked = false;
                    this.tradeTypeError = true;
                }
            }
        } else {
            this.selectedType = trade.type;
            this.wizardCtrl.context.selectedTrade.push(trade);
            this.tradeTypeError = false;
            this.wizardCtrl.context.selectedType = this.selectedType;
        }
    }

    public isChecked(trade) {
        if (this.wizardCtrl.context.selectedTrade != null) {
            for (let item of this.wizardCtrl.context.selectedTrade) {
                if (item.id == trade.id) {
                    return true;
                }
            }
        }
        return false;
    }

    public loadTrades() {
        this.loading = true;

        this.params = {
            start: (this.currentPage - 1) * this.itemsPerPage,
            pageSize: this.itemsPerPage,
            sortColumn: this.sortColumn,
            sortAscending: this.sortAscending
        };

        this.TradeAndTradeProposals.page(
            this.params,
            (res) => {
                this.tradeAndTradeProposals = res;
            },
            (err: any) => {
                this.errorMessage =
                    err && err.data && err.data.message
                        ? err.data.message
                        : 'Unknown error.';
            }
        ).$promise.finally(() => (this.loading = false));
    }

    public cancel(): void {
        this.$location.path('/uploads');
    }

    public submit(isValid): boolean {
        if (!isValid || this.wizardCtrl.context.selectedTrade.length == 0) {
            return false;
        }
        this.wizardCtrl.next();
        return true;
    }

    public changeSortColumn(newSortColumn: string): void {
        this.sortColumn = newSortColumn;
        this.sortAscending = !this.sortAscending;
        this.currentPage = 1;
        this.loadTrades();
    }
}

angular.module('app').component('pkpTradeUploadWizardSelect', {
    controller: UploadWizardSelectComponentCtrl,
    template:
        require('app/trade-upload-wizard/trade-upload-wizard-select.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
